'use client';

import { Footer as ExternalFooter } from '@portals/external-services-footer';
import { APP_VERSION, EAnalytics } from '@/_constants/analytics';
import { useLocaleCountry } from '@/_hooks/use-locale-country';
import { FROM_PARAM } from '@/_constants/query-params';
import { APP_NAMESPACE } from '@/_constants/app-namespace';

const Footer = () => {
  const { country, locale } = useLocaleCountry();

  return (
    <ExternalFooter
      country={country}
      locale={locale}
      fromParam={FROM_PARAM}
      analytics={{
        projectName: APP_NAMESPACE,
        params: {
          appVersion: APP_VERSION,
          country,
          language: locale,
        },
        events: {
          linkClickEventName: EAnalytics.SUPPLIER_LANDING_FOOTER_T,
          socialClickEventName: EAnalytics.SUPPLIER_LANDING_FOOTER_CONTACTS_T,
          onViewEventName: EAnalytics.SUPPLIER_LANDING_FOOTER_V,
        },
      }}
    />
  );
};

export default Footer;
